import { t } from '@lingui/macro';
import { QtyReportingTab, QtyReportingTabType } from './types';

export const QtyReportingTabList: QtyReportingTab[] = [
  { label: t`General`, value: QtyReportingTabType.GENERAL },
  { label: t`Planning & Target Calculations`, value: QtyReportingTabType.PLANNING_TARGET_CALC },
  { label: t`Weld Program Management`, value: QtyReportingTabType.WELD_PROGRAM_MGMT },
  { label: t`Inspection Test Record`, value: QtyReportingTabType.INSPECTION_TEST_RECORD },
];
